import dayjs from "dayjs";

const { useSearchParams } = require("react-router-dom");

const useSearchParamsManager = () => {

    const [searchParams, setSearchParams] = useSearchParams();

    const retrieveDataFromUrl = () => {

        const loadStateFromURL = () => {
            /* DISABLED, FOR THE TIME BEING.
            // Check for auth first like before
            const hasAuthToken = await verifyToken();
            if (!hasAuthToken) {
              navigate('/');
              return;
            }
            */
            // Layers format: layers=Layer1_Name-spatialRes-temporalRes.Layer2_Name-spatialRes-temporalRes...
            // Date format: startDate=YYYY-MM-DD.
            const layersParam = searchParams.get('layers');
            const dateParam = searchParams.get('startDate');

            if(!layersParam || !dateParam) return null;

            const layerEntries = layersParam.split('.');
            const newSelectedLayers = [];
            const newSpatialResolutions = [];
            const newTemporalResolutions = [];

            layerEntries.forEach(entry => {
                const parts = entry.split('-');
                if (parts.length >= 3) {
                    const layerName = parts[0];
                    const spaceRes = parts[1].replace("_",".");
                    const timeRes = parts[2].replace("_",".");

                    newSelectedLayers.push(layerName);
                    newSpatialResolutions.push(spaceRes);
                    newTemporalResolutions.push(timeRes);
                }
            });

            // parses date ot turl
            let parsedDate;
            try {
                parsedDate = dayjs(dateParam);
            } catch (error) {
                console.error('Error parsing date from URL:', error);
                return null;
            }

            if (newSelectedLayers.length > 0 && parsedDate && parsedDate.isValid()) {
                const result = { newSelectedLayers, newSpatialResolutions, newTemporalResolutions, parsedDate };
                return result;
            };
        };

        if (searchParams.size != 0) return loadStateFromURL();
        else return null;

    };

    const setStartDateUrlParam = (newStartDate) => {
        searchParams.set('startDate', newStartDate.format('YYYY-MM-DD'));
        setSearchParams(searchParams);
    };

    const setNewLayerUrlParam = (layerParameters) => {
        const layerString = layerParameters.longName + "-" + layerParameters.spaceResolution.replace(".", "_") + "-" + layerParameters.timeResolution.replace(".", "_");

        const previousLayers = searchParams.get('layers');
        if (previousLayers) searchParams.set('layers', [previousLayers, layerString].join("."));
        else searchParams.set('layers', layerString);

        setSearchParams(searchParams);
    };

    const removeLayerUrlParam = (layerParameters) => {
        const layerString = layerParameters.longName + "-" + layerParameters.spaceResolution.replace(".", "_") + "-" + layerParameters.timeResolution.replace(".", "_");

        const previousLayers = searchParams.get('layers').split(".");
        const updatedLayers = previousLayers.filter((layer) => {
            return layer !== layerString
        });

        searchParams.set("layers", updatedLayers.join("."));
        setSearchParams(searchParams);
    };

    const updateLayerUrlParam = (previousLayerParameters, newLayerParameters) => {
        const previousLayerString = previousLayerParameters.longName + "-" + previousLayerParameters.spaceResolution + "-" + previousLayerParameters.timeResolution;
        const newLayerString = newLayerParameters.longName + "-" + newLayerParameters.spaceResolution + "-" + newLayerParameters.timeResolution;

        const previousLayers = searchParams.get('layers').split(".");
        const updatedLayers = previousLayers.map((layer) => {
            return layer == previousLayerString ? newLayerString : layer
        });

        searchParams.set("layers", updatedLayers.join("."));
        setSearchParams(searchParams);
    };

    const clearLayerUrlParams = () => {
        searchParams.delete("layers");
        searchParams.delete("startDate");

        setSearchParams(searchParams);
    };

    const replaceUrlParams = ({ startDate, layers }) => {
    // Clear all existing params first
    searchParams.forEach((_, key) => searchParams.delete(key));

    // Set new startDate if provided
    if (startDate) {
        searchParams.set('startDate', startDate.format('YYYY-MM-DD'));
    }

    // Set new layers if provided
    if (layers && layers.length > 0) {
        const layerString = layers
            .map(layerParameters =>
                `${layerParameters.longName}-${layerParameters.spaceResolution.replace(".", "_")}-${layerParameters.timeResolution.replace(".", "_")}`
            )
            .join(".");
        searchParams.set('layers', layerString);
    }

    // Apply to URL
    setSearchParams(searchParams);
};

    return { setStartDateUrlParam, setNewLayerUrlParam, removeLayerUrlParam, updateLayerUrlParam, clearLayerUrlParams, retrieveDataFromUrl, replaceUrlParams };

};

export default useSearchParamsManager;